
import { styled } from 'styled-components';

export const SectionTitle = styled.h1`
padding: 64px 0 40px 0;
    font-size: 50px;
    font-weight: 800;
    line-height: 60px;
    color: var(--header-color);
    @media (min-width: 744px) {
        font-size: 70px;
     }
`